import { Options } from "../Config/Options.js";

const Cursor = {
  dom: {
    cursorElm: document.getElementById('js-cursor'),
    triggerElm: document.querySelectorAll('[data-cursor]'),
    mailElm: '[data-cursor="mail"]',
  },
  options: {
    mailClass: 'is-cursorMail',
  },
  init() {
    if(this.dom.cursorElm) {
      window.addEventListener('mousemove', (e) => this.move(e));
      Array.from(this.dom.triggerElm).map((elm) => {
        elm.addEventListener('mouseover', () => this.enter(elm));
        elm.addEventListener('mouseout', () => this.leave());
      })
    }
  },
  move(e){
    this.dom.cursorElm.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
  },
  enter(elm) {
    this.dom.cursorElm.classList.add(Options.act);
    if(elm.matches(this.dom.mailElm)) {
      this.dom.cursorElm.classList.add(this.options.mailClass);
    }
  },
  leave() {
    this.dom.cursorElm.classList.remove(Options.act);
    if(this.dom.cursorElm.classList.contains(this.options.mailClass)) {
      setTimeout(() => {
        this.dom.cursorElm.classList.remove(this.options.mailClass);
      },150);
    }
  }
}

export default Cursor;